import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/context/AuthContext';
import { CartProvider } from '@/context/CartContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import AdminRoute from '@/components/AdminRoute';

// Pages
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import ContactDetailed from '@/pages/ContactDetailed';
import InfoPage from '@/pages/InfoPage';
import WorkflowPage from '@/pages/WorkflowPage';
import ProbeReadyDesign from '@/pages/ProbeReadyDesign';
import CustomProbesPrimers from '@/pages/CustomProbesPrimers';
import PrimerDesignWizardFull from '@/pages/PrimerDesignWizardFull';
import ReadyAssays from '@/pages/ReadyAssays';
import PathogenDetail from '@/pages/PathogenDetail';
import Cart from '@/pages/Cart';
import Checkout from '@/pages/Checkout';
import Orders from '@/pages/Orders';
import AdminDashboard from '@/pages/AdminDashboard';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/contact-detailed" element={<ContactDetailed />} />
              <Route path="/info" element={<InfoPage />} />
              <Route path="/workflow" element={
                <ProtectedRoute>
                  <WorkflowPage />
                </ProtectedRoute>
              } />
              <Route path="/probe-ready-design" element={
                <ProtectedRoute>
                  <ProbeReadyDesign />
                </ProtectedRoute>
              } />
              <Route path="/custom-probes-primers" element={
                <ProtectedRoute>
                  <CustomProbesPrimers />
                </ProtectedRoute>
              } />
              <Route path="/primer-design-wizard" element={
                <ProtectedRoute>
                  <PrimerDesignWizardFull />
                </ProtectedRoute>
              } />
              <Route path="/ready-assays" element={<ReadyAssays />} />
              <Route path="/pathogens" element={<ReadyAssays />} />
              <Route path="/pathogen/:id" element={<PathogenDetail />} />
              <Route path="/cart" element={
                <ProtectedRoute>
                  <Cart />
                </ProtectedRoute>
              } />
              <Route path="/checkout" element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              } />
              <Route path="/orders" element={
                <ProtectedRoute>
                  <Orders />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
